// 小程序全部分类页面
export default {
  routes: [
    {
      path: '/ignore-remind-setting',
      name: 'ignoreRemindSetting',
      meta: {
        desc: '免打扰设置',
        pageId: 'H9981',
        isAutoPV: false
      },
      component: () =>
        import(
          /* webpackChunkName: "IgnoreRemindSetting" */ '../views/ignoreRemindSetting/index.vue'
        )
    }
  ]
}
